import React from 'react';
import ProfitAndLossSummary from 'components/containers/ProfitAndLoss';

const ProfitAndLoss = () => (
  <ProfitAndLossSummary />
);

export default ProfitAndLoss;
